module.exports = __webpack_public_path__ + "img/16-min.f3cb423d.jpg";